<script>
import Modal from "@/components/generic/Modal.vue";

export default {
  name: "PreActionCountryAccess",
  components: { Modal }
};
</script>

<template>
  <Modal class="modal modal--mob u-text-center" :size="'medium'">
    <template #body>
      <img src="@/assets/img/banned-globe.png" alt="" width="80" class="mb">
      <div v-html="$t('general.country_access.blocked')"></div>
    </template>
  </Modal>
</template>

<style scoped lang="scss">

</style>